// In client/src/components/GpaCalculator.js

import React, { useState } from 'react';
import './GpaCalculator.css';

// --- Grade Point Mapping ---
// Customize this to your college's grading system
const gradePoints = {
  'S': 10,
  'A': 9,
  'B': 8,
  'C': 7,
  'D': 6,
  'E': 5,
  'F': 0,
  'Abs': 0 // For Absent/Fail
};
// ----------------------------

const GpaCalculator = () => {
  const [rows, setRows] = useState([
    { subject: '', credits: '', grade: 'S' }
  ]);
  const [gpa, setGpa] = useState(null);

  // Handles changes in any input field (subject, credits, or grade)
  const handleRowChange = (index, event) => {
    const { name, value } = event.target;
    const list = [...rows];
    list[index][name] = value;
    setRows(list);
    setGpa(null); // Reset GPA on any change
  };

  // Adds a new, empty row to the list
  const handleAddRow = () => {
    setRows([...rows, { subject: '', credits: '', grade: 'S' }]);
    setGpa(null);
  };

  // Removes a specific row
  const handleRemoveRow = (index) => {
    const list = [...rows];
    list.splice(index, 1);
    setRows(list);
    setGpa(null);
  };

  // The main calculation logic
  const handleCalculateGpa = () => {
    let totalCredits = 0;
    let totalPoints = 0;
    let calculationPossible = true;

    for (const row of rows) {
      const credits = parseFloat(row.credits);
      const grade = row.grade;

      if (!credits || credits <= 0 || gradePoints[grade] === undefined) {
        calculationPossible = false;
        break; // Stop if any row is invalid
      }

      totalCredits += credits;
      totalPoints += credits * gradePoints[grade];
    }

    if (calculationPossible && totalCredits > 0) {
      const calculatedGpa = totalPoints / totalCredits;
      setGpa(calculatedGpa.toFixed(3)); // Show GPA with 3 decimal places
    } else {
      setGpa(null); // Cannot calculate
      alert("Please ensure all rows have valid credits and a selected grade.");
    }
  };

  // Resets the entire form
  const handleReset = () => {
    setRows([{ subject: '', credits: '', grade: 'O' }]);
    setGpa(null);
  };

  // In client/src/components/GpaCalculator.js

// ... (all your existing JavaScript logic, useState, handlers, etc. go here) ...

  return (
    <div className="gpa-calculator-container">
      <div className="gpa-header">
        <h2>GPA Calculator</h2>
        <p>Enter your subjects, credits, and grades to calculate your GPA.</p>
      </div>

      {/* This is the new two-column wrapper */}
      <div className="gpa-main-content">
        
        {/* --- Left Column: The Form --- */}
        <div className="gpa-form-column">
          <div className="gpa-table-header">
            <span className="header-subject">Subject (Optional)</span>
            <span className="header-credits">Credits</span>
            <span className="header-grade">Grade</span>
            <span className="header-action"></span>
          </div>

          <div className="gpa-table-body">
            {rows.map((row, index) => (
              <div className="gpa-table-row" key={index}>
                <input
                  type="text"
                  name="subject"
                  placeholder={`Subject ${index + 1}`}
                  value={row.subject}
                  onChange={(e) => handleRowChange(index, e)}
                  className="input-subject"
                />
                <input
                  type="number"
                  name="credits"
                  placeholder="e.g., 3"
                  value={row.credits}
                  onChange={(e) => handleRowChange(index, e)}
                  className="input-credits"
                  min="0"
                />
                <select
                  name="grade"
                  value={row.grade}
                  onChange={(e) => handleRowChange(index, e)}
                  className="input-grade"
                >
                  {Object.keys(gradePoints).map(grade => (
                    <option key={grade} value={grade}>{grade}</option>
                  ))}
                </select>
                <button 
                  className="btn-remove-row" 
                  onClick={() => handleRemoveRow(index)}
                >
                  &times;
                </button>
              </div>
            ))}
          </div>
           <button className="btn btn-add" onClick={handleAddRow}>
            + Add Another Subject
          </button>
        </div>

        {/* --- Right Column: Actions & Result --- */}
        <div className="gpa-sidebar-column">
          <div className="gpa-actions-card">
            <h4>Actions</h4>
            <div className="gpa-actions">
              <button className="btn btn-calculate" onClick={handleCalculateGpa}>
                Calculate GPA
              </button>
              <button className="btn btn-reset" onClick={handleReset}>
                Reset All
              </button>
            </div>
          </div>

          {gpa !== null && (
            <div className="gpa-result">
              <h3>Your Semester GPA is:</h3>
              <p>{gpa}</p>
            </div>
          )}
        </div>

      </div> {/* End of gpa-main-content */}
    </div>
  );
};

export default GpaCalculator;